import React from "react";
import { Popover, Tag, Button, Input, Tooltip } from "antd";

class Tags extends React.Component {
  state = {
    popoverVisible: false,
    tags: [],
    inputVisible: false,
    inputValue: ""
  };

  hidePopover = () => {
    this.setState({
      popoverVisible: false
    });
  };

  handleVisibleChange = popoverVisible => {
    this.setState({ popoverVisible });
  };

  handleClose = removedTag => {
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    // console.log(tags);
    this.setState({ tags });
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const state = this.state;
    const inputValue = state.inputValue;
    let tags = state.tags;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, inputValue];
    }
    // console.log(tags);
    this.setState({
      tags,
      inputVisible: false,
      inputValue: ""
    });
  };

  saveInputRef = input => (this.input = input);

  render() {
    const { popoverVisible, tags, inputVisible, inputValue } = this.state;
    return (
      <Popover
        content={
          <div className="tags">
            <div className="tags__title">Sample tags</div>
            <div className="tags__container">
              {tags.map((tag, index) => {
                const isLongTag = tag.length > 20;
                const tagElem = (
                  <Tag
                    className="tags__item"
                    key={tag}
                    closable={true}
                    afterClose={() => this.handleClose(tag)}
                  >
                    {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                  </Tag>
                );
                return isLongTag ? (
                  <Tooltip title={tag} key={tag}>
                    {tagElem}
                  </Tooltip>
                ) : (
                  tagElem
                );
              })}
              {inputVisible && (
                <div className="tags__field">
                  <Input
                    className="tags__input"
                    ref={this.saveInputRef}
                    type="text"
                    size="small"
                    value={inputValue}
                    onChange={this.handleInputChange}
                    onBlur={this.handleInputConfirm}
                    onPressEnter={this.handleInputConfirm}
                  />
                </div>
              )}
              {!inputVisible && (
                <Button
                  className="tags__add"
                  type="primary"
                  onClick={this.showInput}
                >
                  <img src="/img/plus-white.svg" alt="" />
                </Button>
              )}
            </div>
            <div className="tags__foot">
              <Button
                className="tags__btn"
                type="primary"
                onClick={this.hidePopover}
              >
                Cancel
              </Button>
              <Button
                className="tags__btn"
                type="primary"
                onClick={this.hidePopover}
              >
                Save
              </Button>
            </div>
          </div>
        }
        visible={popoverVisible}
        onVisibleChange={this.handleVisibleChange}
        trigger="click"
        placement="bottom"
      >
        <Button className="ant-add">
          <img src="/img/plus-gray.svg" alt="" />
        </Button>
      </Popover>
    );
  }
}

export default Tags;
